import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../../semantic-ui/components/form-input-field';
import { KgIcon, PieceIcon, PriceIcon, VolumeIcon } from '../../../../../../components/text-icon';
import { CustomDatePicker } from '../../../../../../semantic-ui/components/custom-datepicker';
import { FormSelectField } from '../../../../../../semantic-ui/components/form-select-field';
import { normalizeNumber } from '../../../../../../utils/normalizeNumber';
import { normalizeInteger } from '../../../../../../utils/normalizeInteger';
import { CustomRequiredComponent } from '../../../../../../semantic-ui/components/custom-required';
import WeightIcon from '../../../../../../components/icons/weight-icon.svg';
import CountIcon from '../../../../../../components/icons/count-icon.svg';
import SizeIcon from '../../../../../../components/icons/size-icon.svg';
import { FormTextAreaField } from '../../../../../../semantic-ui/components/form-textarea-field';
import { ErrorComponent } from '../../../../../../components/error-component';
import FieldWithCaption from '../../../../../../components/FieldWithCaption';

export const OrderFormView = ({
	customers,
	isCustomersLoading,
	partners,
	addresses,
	contacts,
	onPartnerSearchChange,
	onPartnerChange,
	partnerSearchValue,
	addressSearchValue,
	onAddressChange,
	onAddressSearchChange,
	onContactChange,
	onContactSearchChange,
	contactSearchValue,
	modes,
	isPartnersLoading,
	isAddressesLoading,
	isContactsLoading,
	isModesLoading,
	orderInfo,
	isOrderInfoLoading,
	formValues,
}) => {
	return (
		<Grid className="order-form">
			<Grid.Row className="order-form__row">
				<Grid.Column className="order-form__column-title">Информация о заказе</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Заказчик
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.customer_info}>
						<Field
							name="customer_id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							options={customers}
							search
							loading={isCustomersLoading}
							disabled={isCustomersLoading}
							noResultsMessage="Юр. лица не найдены"
							placeholder="Выберите заказчика"
							isWithoutSelectOnBlur
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Номер заказа
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Field
						name="number"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите номер заказа"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Дата создания заказа
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Field
						name="created_date"
						nameField="created_date"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=". . / . . / . . . ."
						dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row order-form__row_empty" />
			<Grid.Row className="order-form__row">
				<Grid.Column className="order-form__column-title">Информация о Грузоотправителе</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Грузоотправитель
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[0]?.partner_info}>
						<Field
							name="points[0].partner.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							search
							placeholder="Выберите грузоотправителя"
							options={partners[0]}
							noResultsMessage="Грузоотправители не найдены"
							onChange={value => onPartnerChange(value, 0)}
							onSearchChange={value => onPartnerSearchChange(value, 0)}
							searchValue={partnerSearchValue[0]}
							isWithoutSelectOnBlur
							loading={isPartnersLoading || isOrderInfoLoading}
							disabled={isPartnersLoading || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Адрес
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[0]?.address_info}>
						<Field
							name="points[0].address.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите адрес"
							options={addresses[0]}
							noResultsMessage={
								formValues?.points?.[0]?.partner?.id && (!addresses[0] || addressSearchValue[0])
									? 'Адреса не найдены'
									: 'Выберите грузоотправителя'
							}
							onChange={value => onAddressChange(value, 0)}
							search
							onSearchChange={value => onAddressSearchChange(value, 0)}
							searchValue={addressSearchValue[0]}
							isWithoutSelectOnBlur
							loading={isAddressesLoading[0] || isOrderInfoLoading}
							disabled={isAddressesLoading[0] || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Контактное лицо
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[0]?.contact_info}>
						<Field
							name="points[0].contact.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите контактное лицо"
							options={contacts[0] || []}
							noResultsMessage={
								formValues?.points?.[0]?.address?.id && (contacts[0] || contactSearchValue[0])
									? 'Контактные лица не найдены'
									: 'Выберите адрес'
							}
							onChange={value => onContactChange(value, 0)}
							search
							onSearchChange={value => onContactSearchChange(value, 0)}
							searchValue={contactSearchValue[0]}
							isWithoutSelectOnBlur
							loading={isContactsLoading[0] || isOrderInfoLoading}
							disabled={isContactsLoading[0] || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row order-form__row_empty" />
			<Grid.Row className="order-form__row">
				<Grid.Column className="order-form__column-title">Информация о грузе</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Температурный режим
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.mode_info}>
						<Field
							name="mode.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите температурный режим"
							options={modes}
							noResultsMessage="Температурные режимы не найдены"
							search
							isWithoutSelectOnBlur
							loading={isModesLoading || isOrderInfoLoading}
							disabled={isModesLoading || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Заявленная стоимость груза
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Field
						name="cost"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						icon={PriceIcon}
						placeholder="Укажите заявленную стоимость груза"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Габаритные характеристики
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Grid columns={3} className="order-form__wrapper">
						<Grid.Row className="order-form__row order-form__row-cargo">
							<Grid.Column className="order-form__column-cargo" width={5}>
								<img src={WeightIcon} alt="weight-icon" />
								<div className="order-form__field">
									<Field
										name="weight"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={KgIcon}
										placeholder="Масса"
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="order-form__column-cargo" width={5}>
								<img src={SizeIcon} alt="weight-icon" />
								<div className="order-form__field">
									<Field
										name="volume"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={VolumeIcon}
										placeholder="Объем"
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="order-form__column-cargo" width={5}>
								<img src={CountIcon} alt="count-icon" />
								<div className="order-form__field">
									<Field
										name="place"
										type="text"
										normalize={normalizeInteger}
										component={FormInputField}
										autoComplete="off"
										icon={PieceIcon}
										placeholder="Места"
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row className="order-form__row order-form__row-cargo order-form__row-error">
							<Grid.Column className="order-form__column-cargo-error" width={16}>
								<Field name="weight" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="order-form__column-cargo-error" width={16}>
								<Field name="volume" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="order-form__column-cargo-error" width={16}>
								<Field name="place" component={ErrorComponent} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column order-form__column_comment">
					Атрибут группы
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Field
						name="attr_group"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите атрибут группы"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column order-form__column_comment">
					Атрибут маршрута
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Field
						name="attr_way"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите атрибут маршрута"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column order-form__column_comment">
					Примечание
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<Field
						name="comment"
						type="text"
						component={FormTextAreaField}
						autoComplete="off"
						placeholder="Укажите примечание о грузе"
						width="100%"
						resize="vertical"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row order-form__row_empty" />
			<Grid.Row className="order-form__row">
				<Grid.Column className="order-form__column-title">Информация о Грузополучателе</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Грузополучатель
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[1]?.partner_info}>
						<Field
							name="points[1].partner.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите грузополучателя"
							options={partners[1] || []}
							noResultsMessage="Грузополучатели не найдены"
							onChange={value => onPartnerChange(value, 1)}
							search
							onSearchChange={value => onPartnerSearchChange(value, 1)}
							searchValue={partnerSearchValue[1]}
							isWithoutSelectOnBlur
							loading={isPartnersLoading || isOrderInfoLoading}
							disabled={isPartnersLoading || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Адрес
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[1]?.address_info}>
						<Field
							name="points[1].address.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите адрес"
							options={addresses[1] || []}
							noResultsMessage={
								formValues?.points?.[1]?.partner?.id && (addresses[1] || addressSearchValue[1])
									? 'Адреса не найдены'
									: 'Выберите грузополучателя'
							}
							onChange={value => onAddressChange(value, 1)}
							search
							onSearchChange={value => onAddressSearchChange(value, 1)}
							searchValue={addressSearchValue[1]}
							isWithoutSelectOnBlur
							loading={isAddressesLoading[1] || isOrderInfoLoading}
							disabled={isAddressesLoading[1] || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Дата доставки
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={3} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[1]?.date_info}>
						<Field
							name="points[1].date"
							nameField="points[1].date"
							type="text"
							component={CustomDatePicker}
							autoComplete="off"
							placeholder=". . / . . / . . . ."
							dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-form__row">
				<Grid.Column width={6} className="order-form__column">
					Контактное лицо
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-form__column">
					<FieldWithCaption caption={orderInfo?.points?.[1]?.contact_info}>
						<Field
							name="points[1].contact.id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите контактное лицо"
							options={contacts[1] || []}
							noResultsMessage={
								formValues?.points?.[1]?.address?.id && (contacts[1] || contactSearchValue[1])
									? 'Контактные лица не найдены'
									: 'Выберите адрес'
							}
							onChange={value => onContactChange(value, 1)}
							search
							onSearchChange={value => onContactSearchChange(value, 1)}
							searchValue={contactSearchValue[1]}
							isWithoutSelectOnBlur
							loading={isContactsLoading[1] || isOrderInfoLoading}
							disabled={isContactsLoading[1] || isOrderInfoLoading}
						/>
					</FieldWithCaption>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

OrderFormView.propTypes = {
	customers: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isCustomersLoading: PropTypes.bool.isRequired,
	partners: PropTypes.shape({
		0: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.number.isRequired,
				value: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired,
			}),
		),
		1: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.number.isRequired,
				value: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired,
			}),
		),
	}),
	addresses: PropTypes.shape({
		0: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.number.isRequired,
				value: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired,
			}),
		),
		1: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.number.isRequired,
				value: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired,
			}),
		),
	}),
	contacts: PropTypes.shape({
		0: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.number.isRequired,
				value: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired,
			}),
		),
		1: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.number.isRequired,
				value: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired,
			}),
		),
	}),
	orderInfo: PropTypes.object,
	onPartnerSearchChange: PropTypes.func.isRequired,
	onAddressSearchChange: PropTypes.func.isRequired,
	onContactSearchChange: PropTypes.func.isRequired,
	onPartnerChange: PropTypes.func.isRequired,
	onAddressChange: PropTypes.func.isRequired,
	onContactChange: PropTypes.func.isRequired,
	partnerSearchValue: PropTypes.shape({ 0: PropTypes.string, 1: PropTypes.string }).isRequired,
	addressSearchValue: PropTypes.shape({ 0: PropTypes.string, 1: PropTypes.string }).isRequired,
	contactSearchValue: PropTypes.shape({ 0: PropTypes.string, 1: PropTypes.string }).isRequired,
	modes: PropTypes.array.isRequired,
	isPartnersLoading: PropTypes.bool.isRequired,
	isAddressesLoading: PropTypes.object.isRequired,
	isContactsLoading: PropTypes.object.isRequired,
	formValues: PropTypes.object,
	isModesLoading: PropTypes.bool.isRequired,
	isOrderInfoLoading: PropTypes.bool.isRequired,
};
